import { createContext, useContext, useMemo } from "react";

export const Context = createContext<Record<string, boolean>>({});

export function useIsExpandedRow(id: string) {
  const expandedRows = useContext(Context);

  return useMemo(() => expandedRows[id], [id, expandedRows]);
}
